import React from 'react';
import dashboardChart from '../img/dasboard-weight/dashboard.svg';
import dashboardChart2 from '../img/dasboard-weight/finished-good.svg';
import rawMaterial from '../img/dasboard-weight/raw-material.svg';
import { CheckCircleOutlined } from '@ant-design/icons';

const WidgetCard = ({
  title,
  titleColor = '#fff',
  icon,
  iconBg = 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
  accentColor = '#00c6ff',
  value1,
  subtitle1,
  value2,
  subtitle2,
  valueColor = '#fff',
  subtitleColor = '#ccc',
  background = 'linear-gradient(135deg, #23263a 0%, #23263a 100%)',
  ...props
}) => (
  <div
    style={{
      background,
      borderRadius: 16,
      padding: 24,
      minWidth: 280,
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      marginRight: 24,
      boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
      position: 'relative',
      overflow: 'hidden',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'pointer',
      ...props.style,
    }}
    className="dashboard-widget-card"
  >
    {/* Accent bar */}
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: 5,
      background: accentColor,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      opacity: 0.85,
    }} />
    {/* Header */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
      <span style={{ color: titleColor, fontWeight: 700, fontSize: 18, letterSpacing: 1 }}>{title}</span>
      <span style={{
        background: iconBg,
        borderRadius: '50%',
        width: 44,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
      }}>
        {
          title && title.toUpperCase().includes('FINISHED GOOD') && (
            <CheckCircleOutlined />
          )
        }
        {
          title && title.toUpperCase().includes('RAW MATERIAL') && (
            <CheckCircleOutlined />
          )
        }
      </span>
    </div>
    {/* Values */}
    <div style={{ display: 'flex', marginTop: 8, gap: 16 }}>
      <div style={{ flex: 1, textAlign: 'left' }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: valueColor, lineHeight: 1.1 }}>{value1}</div>
        <div style={{ color: subtitleColor, fontSize: 14, marginTop: 2 }}>{subtitle1}</div>
        
      </div>
      <div style={{ flex: 1, textAlign: 'left' }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: valueColor, lineHeight: 1.1 }}>{value2}</div>
        <div style={{ color: subtitleColor, fontSize: 14, marginTop: 2 }}>{subtitle2}</div>
      </div>
      
    </div>
    {/* Add a common chart image for FINISHED GOOD at the bottom */}
    {title && title.toUpperCase().includes('FINISHED GOOD') && (
      <div style={{ width: '100%', marginTop: 18, display: 'flex', justifyContent: 'center' }}>
        <img src={dashboardChart2} alt="Chart" style={{ width: '90%', maxWidth: 180, opacity: 0.92, borderRadius: 8, boxShadow: '0 2px 12px #23263a' }} />
      </div>
    )}
     {title && title.toUpperCase().includes('RAW MATERIAL') && (
      <div style={{ width: '100%', marginTop: -45, display: 'flex', justifyContent: 'center' }}>
        <img src={rawMaterial} alt="Chart" style={{ width: '90%', maxWidth: 180, opacity: 0.92, borderRadius: 8, boxShadow: '0 2px 12px #23263a' }} />
      </div>
    )}
    {/* Hover effect */}
    <style>{`
      .dashboard-widget-card:hover {
        transform: translateY(-4px) scale(1.025);
        box-shadow: 0 8px 32px rgba(0, 198, 255, 0.18);
      }
    `}</style>
  </div>
);

export default WidgetCard;